import { ColumnDef } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

export const useTranslatedColumns = (
  columns: ColumnDef<{ [p: string]: object }, unknown>[],
): ColumnDef<{ [p: string]: object }, unknown>[] => {
  const { t } = useTranslation("common");
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 992);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (isSmallScreen) {
    return columns.map((column) => {
      if (column.header && typeof column.header === "string") {
        return {
          ...column,
          header: t(column.header),
        };
      }
      return column;
    });
  }

  return columns;
};
